import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    {
        path: "/gatesignmanagement/room/ss",//沙市
        meta: { title: '数字门牌', noCache: true },
        component: (resolve) => require(["../page/room/room.vue"], resolve),
    },
    {
        path: "/gatesignmanagement/room/jz",//荆州
        meta: { title: '数字门牌', noCache: true },
        component: (resolve) => require(["../page/room/room.vue"], resolve),
    },
    {
        path: "/gatesignmanagement/room/ga",//公安
        meta: { title: '数字门牌', noCache: true },
        component: (resolve) => require(["../page/room/room.vue"], resolve),
    },
    {
        path: "/gatesignmanagement/room/jglg",//江陵
        meta: { title: '数字门牌', noCache: true },
        component: (resolve) => require(["../page/room/room.vue"], resolve),
    },
    {
        path: "/gatesignmanagement/room/su",//石首
        meta: { title: '数字门牌', noCache: true },
        component: (resolve) => require(["../page/room/room.vue"], resolve),
    },
    {
        path: "/gatesignmanagement/room/hh",//洪湖
        meta: { title: '数字门牌', noCache: true },
        component: (resolve) => require(["../page/room/room.vue"], resolve),
    },
    {
        path: "/gatesignmanagement/room/sz",//松滋
        meta: { title: '数字门牌', noCache: true },
        component: (resolve) => require(["../page/room/room.vue"], resolve),
    },
    {
        path: "/gatesignmanagement/room/jl",//监利
        meta: { title: '数字门牌', noCache: true },
        component: (resolve) => require(["../page/room/room.vue"], resolve),
    }
];

const router = new VueRouter({
    mode: "history",
    // mode: "hash",
    base: '/',
    routes,
});

router.beforeEach(async (to, from, next) => {
    console.log('====to:', to);
    if (to.meta.title === '数字门牌') next();
});

export default router;
